// Package imports:
import React from 'react';
// Component imports:
import LostPasswordForm from './LostPasswordForm';

const LostPassword: React.FC = () => {

    return (
        <div className='main KCL_lost_password-page'>
            <div className="section section--primary">
                 <div className="section__body">
                    <div className="shell">
                        <div className="lost_password_container">
                            <h2>Gleymt lykilorð</h2>
                            <LostPasswordForm />
                            <p className="note">Athugaðu að nýtt lykilorð á við um eftirfarandi kerfi Kóða ehf.</p>
                            <div className="text__image">
                                <p>
                                    <img
                                        src="https://cdn.livemarketdata.com/Images/keldan_icon.svg"
                                        alt="Keldan"
                                        width="30"
                                        height="30"
                                    />
                                    {" "}
                                    Keldan og Keldan App
                                </p>
                                <p>
                                    <img
                                        src="https://cdn.livemarketdata.com/Images/kodiak_pro_icon.svg"
                                        alt="Kodiak Pro"
                                        width="30"
                                        height="30"
                                    />
                                    {" "}
                                    Kodiak Pro
                                </p>
                            </div>
                        </div>
                    </div>
                 </div>
            </div>
        </div>
    )
}

export default LostPassword;